import React from 'react';
import { cn } from './utils';

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: string | number;
  height?: string | number;
  circle?: boolean;
}

export function Skeleton({ className, width, height, circle, style, ...rest }: SkeletonProps) {
  return (
    <div
      className={cn('bh-skeleton', circle && 'bh-skeleton--circle', className)}
      style={{
        width,
        height,
        ...style,
      }}
      aria-hidden
      {...rest}
    />
  );
}
